// React hook exposing live connectivity + offline-queue depth so the UI can
// show an "Offline" chip and a "syncing N" badge. Updates on the browser
// online/offline events and the custom "fj-queue-changed" event emitted by
// offlineQueue.js (enqueue / flush).
import { useEffect, useState } from "react";
import { getQueue, isOnline } from "./offlineQueue";

export function useOfflineStatus() {
  const [online, setOnline] = useState(isOnline());
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let mounted = true;
    const refreshPending = async () => {
      const q = await getQueue();
      if (mounted) setPending(q.length);
    };
    const onOnline = () => { setOnline(true); refreshPending(); };
    const onOffline = () => setOnline(false);
    const onQueue = () => refreshPending();

    refreshPending();
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    window.addEventListener("fj-queue-changed", onQueue);
    // Light poll as a safety net (e.g. native connectivity edge cases).
    const iv = setInterval(() => { setOnline(isOnline()); refreshPending(); }, 5000);
    return () => {
      mounted = false;
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      window.removeEventListener("fj-queue-changed", onQueue);
      clearInterval(iv);
    };
  }, []);

  return { online, pending };
}
